export enum variants {
    common = 'common',
    description = 'description',
    textArea = 'textArea',
}
